import { useLang, LANGS } from "@/i18n";
import { PHONES } from "@/lib/site";
import Logo from "@/components/Logo";
import { Phone } from "lucide-react";

export default function Navbar() {
    const { lang, setLang, t } = useLang();
    return (
        <header className="sticky top-0 z-40 border-b border-emerald-900/5 bg-white/85 backdrop-blur-md">
            <div className="mx-auto flex h-16 max-w-3xl items-center justify-between gap-2 px-4 sm:px-6">
                <a href="#top" aria-label="Azmthullah Packers & Movers">
                    <Logo />
                </a>

                <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-600">
                    {t.nav.links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="transition-colors hover:text-brand"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <div
                        className="flex rounded-full border border-emerald-900/10 bg-white p-1"
                        role="group"
                        aria-label="Language"
                        data-testid="language-selector-dropdown"
                    >
                        {LANGS.map((l) => (
                            <button
                                key={l.code}
                                type="button"
                                onClick={() => setLang(l.code)}
                                data-testid={`lang-${l.code}-button`}
                                className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${
                                    lang === l.code
                                        ? "bg-brand text-white"
                                        : "text-slate-500 hover:text-brand"
                                }`}
                            >
                                {l.label}
                            </button>
                        ))}
                    </div>

                    <a
                        href={`tel:${PHONES[0].tel}`}
                        data-testid="nav-call-now-button"
                        className="hidden sm:inline-flex h-9 items-center gap-1.5 rounded-full bg-brand px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-dark"
                    >
                        <Phone className="h-3.5 w-3.5" />
                        {t.nav.call}
                    </a>
                    <a
                        href={`tel:${PHONES[0].tel}`}
                        data-testid="nav-call-now-button-mobile"
                        aria-label={t.nav.call}
                        className="sm:hidden inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white transition-colors hover:bg-brand-dark"
                    >
                        <Phone className="h-4 w-4" />
                    </a>
                </div>
            </div>
        </header>
    );
}
